module.exports = __webpack_public_path__ + "media/MRI20-ad.cffaeaa3.mp3";